export var FilterPartTypeEnum;
(function (FilterPartTypeEnum) {
    FilterPartTypeEnum["PAYLOAD"] = "payload";
    FilterPartTypeEnum["SUBSCRIBER"] = "subscriber";
    FilterPartTypeEnum["WEBHOOK"] = "webhook";
    FilterPartTypeEnum["IS_ONLINE"] = "isOnline";
    FilterPartTypeEnum["IS_ONLINE_IN_LAST"] = "isOnlineInLast";
})(FilterPartTypeEnum || (FilterPartTypeEnum = {}));
